import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

// Component to protect routes based on authentication and user role
const ProtectedRoute = ({ allowedRoles }) => {
  const { currentUser, loading } = useContext(AuthContext);
  const location = useLocation();
  const { orgDomain } = useParams();
  
  // If still loading auth status, show loading indicator
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  
  // If not authenticated, redirect to login
  if (!currentUser) { 
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  
  // Handle organization context mismatch
  if (orgDomain && currentUser.organization_domain && orgDomain !== currentUser.organization_domain) {
    console.log('ProtectedRoute: Organization domain mismatch, redirecting to correct org');
    return <Navigate to={`/${currentUser.organization_domain}${location.pathname.split('/').slice(2).join('/')}`} replace />;
  }
  
  // If allowedRoles is specified, check if user has required role
  if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
    console.log('ProtectedRoute: Role not allowed, redirecting to appropriate dashboard');
    // Get the correct dashboard URL based on organization context
    const dashboardPath = currentUser.role === 'superadmin' ? 
      '/superadmin/dashboard' : 
      `/${currentUser.organization_domain || orgDomain}/${currentUser.role}/dashboard`;
    
    return <Navigate to={dashboardPath} replace />;
  }
  
  // If authorized, render the child routes
  return <Outlet />;
};

export default ProtectedRoute; 